import { Pipe, PipeTransform } from '@angular/core';
import { ItemConfig, ItemProfile, ItemProperties, ItemResource, Link, ResourceMeta } from '@ngx-hal/models';
import { PropertiesProfilesPipe } from '../properties-profiles/properties-profiles.pipe';
import { PropertyResourceMetaPipe } from '../property-resource-meta/property-resource-meta.pipe';

@Pipe({
  name: 'rangeParams',
  standalone: true,
})
export class RangeParamsPipe implements PipeTransform {
  /**
   * Transforms the provided resource metadata and sample entity into an array of filter parameter pairs
   * suitable for range-based filtering in query strings.
   */
  transform<Entity extends ItemResource>(
    resourceMeta: ResourceMeta<Entity>,
    itemsProfileMap?: Map<Link['href'], ItemProfile<Entity>>,
    itemConfig?: ItemConfig<Entity>,
    sample?: Partial<Entity>,
    prefix?: string,
  ): string[][] {
    const itemProfile = itemsProfileMap?.get(resourceMeta.profile.href);

    return itemProfile
      ? new PropertiesProfilesPipe()
          .transform(itemProfile, itemConfig, { remove: { children: true } })
          .filter(property => sample?.[property.alps.name] !== undefined)
          .map(property => {
            const subResourceMeta = new PropertyResourceMetaPipe().transform(property);
            if (subResourceMeta) {
              return this.transform(
                subResourceMeta,
                itemsProfileMap,
                itemConfig?.[property.alps.name],
                sample?.[property.alps.name] as Partial<Entity>,
                `${property.alps.name}.`,
              );
            } else {
              if (itemConfig?.[property.alps.name]?._customFilter) {
                const [range1, range2, includeNull] = (sample?.[property.alps.name] as string).split(',');
                if (includeNull) {
                  return [
                    [`${prefix ?? ''}${property.alps.name}`, range1],
                    [`${prefix ?? ''}${property.alps.name}`, range2],
                    [`${prefix ?? ''}${property.alps.name}`, ''],
                  ];
                }
                return [
                  [`${prefix ?? ''}${property.alps.name}`, range1],
                  [`${prefix ?? ''}${property.alps.name}`, range2],
                ];
              }
              if (property.schema?.type === 'integer' && sample?.[property.alps.name]?.toString().includes(',')) {
                const valuesArr = (sample?.[property.alps.name] as string).split(',');
                return valuesArr.map(v => [`${prefix ?? ''}${property.alps.name}`, v]);
              }
              return [];
            }
          })
          .flat()
      : [];
  }
}
